import moment from 'moment';
import React, { FunctionComponent } from 'react';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import pure from 'recompose/pure';
import messages from '../intl/messages';
import { AppState } from '../store/model';
import {
  getDestinations,
  getEndDate,
  getError,
  getStartDate,
  isLoading,
} from '../store/reducers/itinerary/selectors';
import { PageHeaderWithSubheading } from './lab/TextGroup/PageHeaderWithSubheading';

const format = 'ddd D MMM';

interface OwnProps {}

interface StateProps {
  destinations?: string[];
  startDate?: Date;
  endDate?: Date;
}

interface TripToProps extends OwnProps, StateProps, InjectedIntlProps {}

const TripToBase: FunctionComponent<TripToProps> = ({
  destinations,
  startDate,
  endDate,
  intl: { formatMessage },
}: TripToProps) => {
  if (!(location && startDate && endDate)) return null;

  const start = moment(startDate);
  const end = moment(endDate);

  return (
    <PageHeaderWithSubheading
      pageHeader={formatMessage(messages.common.tripTo, {
        location: (destinations || []).join(', '),
      })}
      subheading={
        <>
          {start!.format(format)}
          {start!.year() !== end!.year() && start!.format(' YYYY')}
          {` - `}
          {end!.format(format)}
          {end!.format(' YYYY')}
        </>
      }
    />
  );
};

const mapStateToProps = (state: AppState): StateProps => {
  return !isLoading(state) && !getError(state)
    ? {
        destinations: getDestinations(state),
        startDate: getStartDate(state),
        endDate: getEndDate(state),
      }
    : {};
};

const enhance = compose<TripToProps, OwnProps>(
  pure,
  connect(mapStateToProps),
  injectIntl,
);

/**
 * Page header
 *
 * @example "Trip to Auckland"
 */
export const TripTo = enhance(TripToBase);

TripTo.displayName = 'TripTo';
